module.exports = __webpack_public_path__ + "static/contact-6144e85bfb66713bef3a849cccd8fa70.jpg";